import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

export default function Transcription() {
  const classes = useStyles();
  const { transcript } = useSelector(({ message }) => ({ transcript: message.transcript }));
  let previousName = '';

  return (
    <Box className={classes.root}>
      <Typography variant="h5">Transcripts</Typography>
      <hr />
      <Box className={classes.textBox}>
        {transcript.map((text, index) => {
          if (previousName !== text.name) {
            previousName = text.name;
            return (
              <div key={index}>
                <Typography variant="subtitle2">[{text.name}]</Typography>
                <Typography variant="body1">{text.speech}</Typography>
              </div>
            );
          } else {
            return <div key={index}>{text.speech}</div>;
          }
        })}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: '1.5em',
    paddingTop: '.5em',
    paddingRight: '.5em',
    height: '100vh',
  },
  textBox: {
    height: 'calc(100vh - 53px)',
    overflowY: 'auto',
  },
}));
